<div class="w-100 d-flex flex-column align-items-center justify-content-center">
  <div>
    <img src="../../../../assets/img/logo-enexdirecto.png" class="img-fluid mt-4 mb-5" />
  </div>

  <h2 class="text-center mb-4">Ingresa a tu cuenta</h2>
</div>


<div class="login-container px-4 px-md-3 mb-5">


  <form [formGroup]="formLogin" (submit)="login()">
    <div class="form-group">
      <div class="custom-input-group mb-3">
        <div class="input-group-prepend">
          <span class="icon-RUT-empresa---cliente"></span>
        </div>
        <input type="text" id="companyRut" class="form-control" placeholder="RUT empresa / cliente"
          aria-label="RUT empresa / cliente" formControlName="companyRut"
          [class.border-danger]="f.companyRut.errors && (f.companyRut.dirty || f.companyRut.touched)">
        <div class="form-message">
          <small>*Obligatorio</small>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="custom-input-group mb-3">
        <div class="input-group-prepend">
          <span class="icon-Rut-usuario"></span>
        </div>
        <input type="text" id="userRut" class="form-control" placeholder="RUT usuario" aria-label="RUT usuario"
          formControlName="userRut" [class.border-danger]="f.userRut.errors && (f.userRut.dirty || f.userRut.touched)">
        <div class="form-message">
          <small>*Obligatorio</small>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="custom-input-group mb-3">
        <div class="input-group-prepend">
          <span class="icon-Contrasena"></span>
        </div>
        <input [type]="showPassword? 'text' : 'password'" id="password" class="form-control" placeholder="Contraseña"
          aria-label="Contraseña" formControlName="password"
          [class.border-danger]="f.password.errors && (f.password.dirty || f.password.touched)">
        <div class="input-group-append">
          <span class="icon-Ver-contrasena" (click)="showPasswordHandle()"></span>
        </div>
        <div class="form-message">
          <small>*Obligatorio</small>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column flex-md-row justify-content-md-between align-items-center mb-4">
      <label class="container-check mb-3 mb-md-0">
        Recuérdame
        <input type="checkbox" id="rememberMe" formControlName="rememberMe">
        <span class="checkmark"></span>
      </label>
      <a href="javascript:" (click)="forgot()">Olvidé mi contraseña</a>
    </div>

    <div class="alert alert-danger alert-dismissible fade show mt-3" *ngIf="error.status" role="alert">
      {{ error.descripcion }}
    </div>

    <div class="form-group">
      <div class="custom-input-group mb-3">
        <re-captcha
          (resolved)="resolved($event)"
          [siteKey]="googleCaptchaSiteKey"
          formControlName="recaptchaReactive"
        ></re-captcha>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-12 col-md-10 mx-auto d-flex flex-column justify-content-center">
        <button type="submit" class="btn btn-success btn-block mb-0" [disabled]="formLogin.invalid">
          <span *ngIf="!loader.login;else tmpLoader">Ingresar</span>
        </button>
      </div>
      <div class="col-12 col-md-10 mx-auto d-flex flex-column justify-content-center">
        <button type="button" class="btn mb-4 btn-register" (click)="goToSignUp()">
          ¿No tienes una cuenta? Regístrate
        </button>
      </div>

      <div class="col-10 col-md-10 mx-auto d-flex align-items-center justify-content-center mb-5">
        <button type="button" class="btn btn-primary btn-block position-relative" (click)="goToRegisterExpressRetail()">
          <span>Registro cliente Enex Express+</span>
        </button>
        <div class="position-absolute custom-element">
          <i class="bi bi-question-circle-fill  fs-26 text-dark-50" container="body" [ngbTooltip]="'Enex Express+ es nuestro servicio de diésel a domicilio entre 200 y 1.000 litros sin requisitos financieros previos.'"></i>
        </div>
      </div>

      

    </div>
  </form>
  <div style="align-self: center;">
    <img src="../../../../assets/img/logo-enex.svg" class="img-fluid logo-enex mx-auto" />
  </div>
</div>


<ng-template #tmpLoader>
  <span class="spinner-border text-white" role="status">
    <span class="sr-only">Loading...</span>
  </span>
</ng-template>
